// Phase 5.106 — ProjectsListPage Sort-Key in localStorage.
//
// Vier Optionen, deckt Daily-Workflow (zuletzt bearbeitet),
// Onboarding-/Neu-Sicht (zuletzt erstellt), alphabetischer Quick-Scan
// (Code) und Sales-Priorisierung (Offerten-Wert hoechster zuerst) ab.
//
// Honest Pushback gegenueber Spec-Wortlaut "Deckungsbeitrag (db_desc)":
// RankedProject hat KEIN Deckungsbeitrag-Feld — calc_data.summary ist
// nicht im Listen-Payload. Ersatz `offer_desc` ueber `offerAmount`
// (Drizzle-numeric-as-string, im Endpoint vorhanden). Deckt dieselbe
// Sales-Priorisierungs-Intention. Echter DB-Sort braucht eigenen
// Backend-Sort + Pre-Aggregation und ist ein eigener Baustein.

//
// NAV-3 — fuenfte Option «Stillstand (laengster zuerst)»: die Sortierung der
// aufgeloesten /pipeline-Seite. Sie haengt am Stillstand-Wert der Zeile
// (ranked-Extra `stillstand`, dieselbe Rechnung wie der Stillstand-Waechter
// der Startseite); Zeilen ohne Wert (ausserhalb der offenen Verkaufs-
// Pipeline) stehen unten.

export const PROJECTS_LIST_SORT_KEYS = [
  "updated_desc",
  "created_desc",
  "code_asc",
  "offer_desc",
  "stillstand_desc",
] as const;
export type ProjectsListSortKey = (typeof PROJECTS_LIST_SORT_KEYS)[number];

export const PROJECTS_LIST_SORT_DEFAULT: ProjectsListSortKey = "updated_desc";

export const PROJECTS_LIST_SORT_LABELS: Record<ProjectsListSortKey, string> = {
  updated_desc: "Zuletzt bearbeitet",
  created_desc: "Zuletzt erstellt",
  code_asc: "Code (A-Z)",
  offer_desc: "Offerten-Wert (höchster zuerst)",
  stillstand_desc: "Stillstand (längster zuerst)",
};

// NAV-3 — die Sortierung ist per URL adressierbar (?sort=…, analog ?phase=),
// damit Startseiten-Links direkt hinfuehren. Ein Wort pro Sortierung; der
// Wert wird beim Lesen wie ein Klick behandelt (gesetzt UND gemerkt), die
// URL danach bereinigt. Unbekanntes wird ignoriert, nicht geraten.
export const PROJECTS_LIST_SORT_PARAMS: Record<ProjectsListSortKey, string> = {
  updated_desc: "bearbeitet",
  created_desc: "erstellt",
  code_asc: "code",
  offer_desc: "offerte",
  stillstand_desc: "stillstand",
};

export function resolveProjectsListSortParam(
  param: string | null,
): ProjectsListSortKey | null {
  if (param === null) return null;
  for (const key of PROJECTS_LIST_SORT_KEYS) {
    if (PROJECTS_LIST_SORT_PARAMS[key] === param) return key;
  }
  return null;
}

const STORAGE_KEY = "projects-list.activeSort";

function isValidSortKey(value: string | null): value is ProjectsListSortKey {
  return (
    value !== null &&
    (PROJECTS_LIST_SORT_KEYS as readonly string[]).includes(value)
  );
}

export function readProjectsListSort(): ProjectsListSortKey {
  if (typeof window === "undefined") return PROJECTS_LIST_SORT_DEFAULT;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (isValidSortKey(raw)) return raw;
    return PROJECTS_LIST_SORT_DEFAULT;
  } catch {
    return PROJECTS_LIST_SORT_DEFAULT;
  }
}

export function writeProjectsListSort(sort: ProjectsListSortKey): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, sort);
  } catch {
    // localStorage gesperrt — silent ignore.
  }
}
